import { NavLink, Outlet } from 'react-router'
import type { JSX } from 'react'
import { may, useActiveTenant } from '@/tenant/context'
import { SETTINGS_PANELS } from './panels'

/**
 * Eight panels, one page, no modal mazes (S-D3).
 *
 * A panel is hidden — not disabled — when the role cannot read it, because
 * "you may not see this" and "this does not exist yet" are different statements
 * and showing both the same way would teach people to ignore both. The API
 * refuses regardless; this only keeps the UI from offering a 403.
 */
export function SettingsLayout(): JSX.Element {
  const { role } = useActiveTenant()

  return (
    <>
      <h1 className="ar-h1">Settings</h1>
      <div className="app-settings">
        <nav className="app-settings__nav" aria-label="Settings sections">
          {SETTINGS_PANELS.filter((panel) => !panel.permission || may(role, panel.permission)).map(
            (panel) =>
              panel.to ? (
                <NavLink key={panel.label} to={panel.to}>
                  {panel.label}
                </NavLink>
              ) : (
                <span key={panel.label} aria-disabled="true">
                  {panel.label}
                  <span className="app-nav__soon">Soon</span>
                </span>
              ),
          )}
        </nav>
        <div>
          <Outlet />
        </div>
      </div>
    </>
  )
}
